/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectWithRuntimeStatus } from './ProjectWithRuntimeStatus';
import {
    ProjectWithRuntimeStatusFromJSON,
    ProjectWithRuntimeStatusFromJSONTyped,
    ProjectWithRuntimeStatusToJSON,
    ProjectWithRuntimeStatusToJSONTyped,
} from './ProjectWithRuntimeStatus';

/**
 * 
 * @export
 * @interface RuntimeStatus
 */
export interface RuntimeStatus {
    /**
     * 
     * @type {Array<ProjectWithRuntimeStatus>}
     * @memberof RuntimeStatus
     */
    projects?: Array<ProjectWithRuntimeStatus>;
    /**
     * 
     * @type {string}
     * @memberof RuntimeStatus
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeStatus
     */
    phpVersion?: string;
}

/**
 * Check if a given object implements the RuntimeStatus interface.
 */
export function instanceOfRuntimeStatus(value: object): value is RuntimeStatus {
    return true;
}

export function RuntimeStatusFromJSON(json: any): RuntimeStatus {
    return RuntimeStatusFromJSONTyped(json, false);
}

export function RuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'projects': json['projects'] == null ? undefined : ((json['projects'] as Array<any>).map(ProjectWithRuntimeStatusFromJSON)),
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'phpVersion': json['phpVersion'] == null ? undefined : json['phpVersion'],
    };
}

export function RuntimeStatusToJSON(json: any): RuntimeStatus {
    return RuntimeStatusToJSONTyped(json, false);
}

export function RuntimeStatusToJSONTyped(value?: RuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projects': value['projects'] == null ? undefined : ((value['projects'] as Array<any>).map(ProjectWithRuntimeStatusToJSON)),
        'timezone': value['timezone'],
        'phpVersion': value['phpVersion'],
    };
}

